import { ActionButtonWidth } from 'components/common-form/sidePanel/actions/shared/types';
import { connect } from 'react-redux';
import type { QuoteAction, QuoteActionName } from 'state/common-form/infos/infos.model';
import { getActiveQuoteActionFor } from 'state/selectors';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';
import { selectQuoteAction } from 'state/uiPanelState/quoteActions/quoteActions.action';
import type { WorkspaceType } from 'state/workspaces/model';
import { getWorkspaceType } from 'state/workspaces/tabs/tabs.selector';
export interface OwnProps {
  tabId: string;
  action: QuoteAction;
  advancedAction?: QuoteAction;
  isDisabled: boolean;
  width?: ActionButtonWidth;
  tooltip?: string;
  className?: string;
  onQuoteAction: (name: QuoteActionName) => void;
}
export interface StateProps {
  selectedAction: QuoteActionName;
  workspaceType?: WorkspaceType;
}

interface DispatchProps {
  selectAction: (actionName: QuoteActionName) => void;
}

export type PairedActionsButtonProps = OwnProps & StateProps & DispatchProps;

const mapDispatchToProps = (dispatch: ThunkDispatch, { tabId }: OwnProps): DispatchProps => ({
  selectAction: (actionName: QuoteActionName) => dispatch(selectQuoteAction(actionName, tabId)),
});

const mapStateToProps = (state: AppState, { tabId, action }: OwnProps): StateProps => {
  const selectedAction = getActiveQuoteActionFor(state, tabId, action.name) as QuoteActionName;
  const workspaceType = getWorkspaceType(state, tabId);

  return {
    selectedAction,
    workspaceType,
  };
};
export const connectPairedActionsButton = connect(mapStateToProps, mapDispatchToProps);
